{
  "DE": "Deutschland",
  "AT": "Österreich",
  "BE": "Belgien",
  "DK": "Dänemark",
  "ES": "Spanien",
  "FR": "Frankreich",
  "IE": "Irland",
  "IT": "Italien",
  "LU": "Luxemburg",
  "MC": "Monaco",
  "NL": "Niederlande",
  "PL": "Polen",
  "PT": "Portugal",
  "SE": "Schweden"
}
